import { Component } from "preact";

import { Store } from "@/db";

export default class FileImport extends Component<{ store: Store }> {
  state = { dragging: false }

  render() {
    return <div class={ "ebird-import drop-target" + (this.state.dragging ? ' dragging' : '') }
      onDrop={ this.onFileDrop } onDragOver={ this.onDragOver }
      onDragEnd={ this.onDragEnd } onDragLeave={ this.onDragEnd }>
      <div class="drop-content">
        <img src="/img/download.svg" />
        <div class="file-picker">
          <input id="file-input" type="file" accept=".csv" onChange={ this.onFileChange } />
          <label for="file-input" class="file-input-label">Pick your eBird file</label>
          <span class='or-drag'></span>
        </div>
        <p class="ebird-download">
          { 'Download your eBird data at ' }
          <a href="https://ebird.org/downloadMyData" target="_blank">this page</a>
        </p>
      </div>
    </div>;
  }

  importFile = async (file: File) => {
    console.log('import-file: size:', file.size)
    console.time('import-file');
    await this.props.store.importObservations(file);
    console.timeEnd('import-file');
    document.location.href = "/";
  };

  onFileChange = async (evt: Event) => {
    const target = evt.target as HTMLInputElement|null;
    const files = target?.files ?? [];
    if (files.length > 0) {
      await this.importFile(files[0]);
    } else {
      console.log("pick: no files");
    }
  };

  onFileDrop = async (evt: DragEvent) => {
    evt.preventDefault();
    if (!evt.dataTransfer) { return }

    const item = [...evt.dataTransfer.items].find(item => item.kind === 'file');
    if (item != null) {
      await this.importFile(item.getAsFile()!);
    } else {
      console.log("drop: no files");
    }
  };

  onDragOver = (evt: DragEvent) => {
    evt.preventDefault();
    this.setState({ dragging: true });
  };
  onDragEnd = (evt: DragEvent) => {
    evt.preventDefault();
    this.setState({ dragging: false });
  }
}
